require('./hireCardAtHomeAbroadView.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @actions
const hireCardAtHomeAbroadActions = require('actions/hireCardAtHomeAbroad');
const preContractualMailActions = require('actions/contactCenter/preContractualMailInfo/preContractualMailInfo');
const profileActions = require('actions/profile');
const shippingAddressAction = require('actions/shippingAddress');
const mergePreContractualsPDF = require('actions/mergePreContractualsPDF');
const blockedAccountsAction = require('actions/blockedAccounts');
const precontractualDocumentMailAction = require('actions/precontractualDocumentsMailer');
const termsAndCondsInfoActions = require('actions/termsAndCondsInfo');

// @commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @components
const HireCardAtHomeAbroadStep1 = require('components/hire/cardAtHomeAbroad/hireCardAtHomeAbroadStep1/hireCardAtHomeAbroadStep1');
const HireCardAtHomeAbroadStep2 = require('components/hire/cardAtHomeAbroad/hireCardAtHomeAbroadStep2/hireCardAtHomeAbroadStep2');
const HireCardAtHomeAbroadStep3 = require('components/hire/cardAtHomeAbroad/hireCardAtHomeAbroadStep3/hireCardAtHomeAbroadStep3');
const HireCardAtHomeAbroadStep4 = require('components/hire/cardAtHomeAbroad/hireCardAtHomeAbroadStep4/hireCardAtHomeAbroadStep4');
const HireCardAtHomeAbroadStep5 = require('components/hire/cardAtHomeAbroad/hireCardAtHomeAbroadStep5/hireCardAtHomeAbroadStep5');
const HireCardAtHomeAbroadSuccess = require('components/hire/cardAtHomeAbroad/hireCardAtHomeAbroadSuccess/hireCardAtHomeAbroadSuccess');
const HireCardAtHomeAbroadError = require('components/hire/cardAtHomeAbroad/hireCardAtHomeAbroadError/hireCardAtHomeAbroadError');
const HireCardSidebar = require('components/hire/hireCardSidebar/hireCardSidebar');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const WebappRender = require('components/conditionalRender/webappRender')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')

// @constants
const {
    DEBIT_AT_HOME_ABROAD_STANDARD,
    DEBIT_AT_HOME_ABROAD_SUBTYPE,
    DEBIT_CARD_TYPE,
    FIRST_STEP,
    REDIRECT_URL,
    THIRD_STEP,
    WIZARD_FIRST_STEP,
} = require('constants/index');
const { HIRE_CARD_AT_HOME_ABROAD } = require('constants/operationCodesAccounts');
const { WEB_INACTIVE_ACCOUNT_ENABLED, ES_COUNTRY, MESSAGE_HIRE_24H } = require('constants/flagBasedFeatures');
const { catalogue, analyticsId} = require('components/hire/cardAtHomeAbroad/analytics/hireCardAtHomeAbroadAnalytics');

class HireCardAtHomeAbroadView extends React.Component {
    constructor(props) {
        super(props);
        this.isReady = this.isReady.bind(this);
        this.handleCancel = this.handleCancel.bind(this);

        if (!props.atHomeAbroadEnabled) {
            props.history.push('/myprofile/cards');
        }
    }

    componentDidMount() {
        const {
            getshippingAddressList,
            getBlockedAccounts,
            immAccounts,
            match: { params: { redirect } },
            resetPrecontractualDocumentMail,
            validateStep
        } = this.props;

        resetPrecontractualDocumentMail();
        getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_CARD_AT_HOME_ABROAD);

        if (redirect === REDIRECT_URL) {
            validateStep(WIZARD_FIRST_STEP);
        }

        if (__CONTACT_CENTER__) {
            const { getPrecontractualInfoLink } = this.props
            getPrecontractualInfoLink({
                estandar: DEBIT_AT_HOME_ABROAD_STANDARD,
                subtipo: DEBIT_AT_HOME_ABROAD_SUBTYPE,
                tipo: DEBIT_CARD_TYPE,
            });
        }

        getshippingAddressList();
    }

    componentWillUnmount() {
        const {
            reset,
            resetBlockedAccounts,
            resetPrecontractualMail,
            resetTermsAndCondsText,
        } = this.props

        reset();
        resetBlockedAccounts();
        resetTermsAndCondsText();
        if (__CONTACT_CENTER__) resetPrecontractualMail();
    }

    getProcessDetail() {
        return `${DEBIT_CARD_TYPE}.${DEBIT_AT_HOME_ABROAD_SUBTYPE}`;
    }

    handleCancel() {
        this.props.history.push('/myprofile/cards');
    }

    isReady() { // it warns the user if he's about to lose changes
        const { immHireCardAtHomeAbroad } = this.props;
        let showPreLeaveModal = true;

        if (immHireCardAtHomeAbroad.get('visibleStep') === 1) {
            showPreLeaveModal = false;
        }

        return showPreLeaveModal;
    }

    buildSuccessful() {
        const {
            immAccounts,
            immHireCardImageSelector,
            immHireCardNameSelector,
            immHireCardAtHomeAbroad,
            immProfile,
            immShippingAddressList
        } = this.props;
        const selectedAccount = immHireCardAtHomeAbroad.getIn(['steps', THIRD_STEP, 'accountId']);
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);

        const processDetail = this.getProcessDetail();

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <HireCardAtHomeAbroadSuccess
                    immAccount={immAccount}
                    immHireCardAtHomeAbroad={immHireCardAtHomeAbroad}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireCardNameSelector={immHireCardNameSelector}
                    immProfile={immProfile}
                    immShippingAddress={immShippingAddressList.get('shippingAddress')}
                    processDetail={processDetail}
                />
            </div>
        );
    }

    buildWizardHiringSteps() {
        const {
            gestorCrossEnabled,
            handleAccountChange,
            handleAgreementCheckboxChange,
            hireCardAtHomeAbroad,
            immAccounts,
            immFlagBasedFeatures,
            immHireCardImageSelector,
            immHireCardNameSelector,
            immHireCardAtHomeAbroad,
            immHireContactData,
            immHireInformation,
            immHiringProductInformation,
            immPdfData,
            immPreContractualMail,
            immProfile,
            immShippingAddressList,
            requestPDFMerge,
            requestProfile,
            sendPrecontractualDocumentMail,
            setAllAccountsToInactive,
            setTermsAndCondsText,
            sendPreContractualMail,
            setShippingAddress,
            setVisibleStep,
            setWillCancel,
            validateStep
        } = this.props;
        const wizardActions = {
            cancel: this.handleCancel,
            finish: hireCardAtHomeAbroad,
            setVisibleStep,
            setWillCancel,
            validateStep
        };
        const showPreLeaveModal = this.isReady();
        const immSteps = immHireCardAtHomeAbroad.get('steps');
        const sendMailParams = {
            type: DEBIT_CARD_TYPE,
            subType: DEBIT_AT_HOME_ABROAD_SUBTYPE,
            standar: DEBIT_AT_HOME_ABROAD_STANDARD
        };
        const immShippingAddress = immShippingAddressList.get('shippingAddress');
        const hasShippingAddress = true;
        const nextButtonDisabledStep2 = immHireCardImageSelector.get('isFetching') || immHireCardNameSelector.get('isFetching');

        const productName = this.getProcessDetail();
        const tealiumData = [
            catalogue[analyticsId.AT_HOME_ABROAD_CARD_STEP_1_VIEW]({ productName }),
            catalogue[analyticsId.AT_HOME_ABROAD_CARD_STEP_2_VIEW]({ productName }),
            catalogue[analyticsId.AT_HOME_ABROAD_CARD_STEP_3_VIEW]({ productName }),
            catalogue[analyticsId.AT_HOME_ABROAD_CARD_STEP_4_VIEW]({ productName }),
            catalogue[analyticsId.AT_HOME_ABROAD_CARD_STEP_5_VIEW]({ productName }),
        ];
        const isShippingAddressButtonDisabled = !!immShippingAddressList && !immShippingAddressList.get('shippingAddressType') && immFlagBasedFeatures.get(ES_COUNTRY);
        const loadingFlag = immHireCardAtHomeAbroad.get('loadingFlag');

        return (
            <div>
                <div className="col-xs-12 col-md-8">
                    <Wizard
                        actions={wizardActions}
                        immSteps={immSteps}
                        showPreLeaveModal={showPreLeaveModal}
                        stepsAmount={immSteps.size}
                        tealium={tealiumData[immHireCardAtHomeAbroad.get('visibleStep') - 1]}
                        visibleStep={immHireCardAtHomeAbroad.get('visibleStep')}
                        wizardClass="hire-card-at-home-abroad__wizard"
                        isTaggingSecondVersion
                    >
                        <WizardStep
                            isLoading={loadingFlag}
                            cancelButton={true}
                            position="first"
                        >
                            <WebappRender>
                                <HireCardAtHomeAbroadStep1
                                    flagBasedFeatures={immFlagBasedFeatures}
                                    gestorCrossEnabled={gestorCrossEnabled}
                                    hireCmsKey="athomeabroad"
                                    immHireInformation={immHireInformation}
                                    immHiringProductInformation={immHiringProductInformation}
                                    requestPDFMerge={requestPDFMerge}
                                />
                            </WebappRender>
                            <ContactCenterRender>
                                <HireCardAtHomeAbroadStep1
                                    contractName="at-home-abroad"
                                    flagBasedFeatures={immFlagBasedFeatures}
                                    gestorCrossEnabled={gestorCrossEnabled}
                                    handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                                    hireCmsKey="athomeabroad"
                                    immHireCardAtHomeAbroad={immHireCardAtHomeAbroad}
                                    immHireInformation={immHireInformation}
                                    immHiringProductInformation={immHiringProductInformation}
                                    immPreContractualMail={immPreContractualMail}
                                    immProfileFields={immProfile}
                                    requestProfile={requestProfile}
                                    sendMailParams={sendMailParams}
                                    sendPreContractualMail={sendPreContractualMail}
                                    requestPDFMerge={requestPDFMerge}
                                    setTermsAndCondsText={setTermsAndCondsText}
                                />
                            </ContactCenterRender>
                        </WizardStep>
                        <WizardStep
                            cancelButton={true}
                            nextButtonDisabled={nextButtonDisabledStep2}
                            onBackClick={false}
                            position="middle"
                        >
                            <HireCardAtHomeAbroadStep2
                                immHireCardImageSelector={immHireCardImageSelector}
                                immHireCardNameSelector={immHireCardNameSelector}
                            />
                        </WizardStep>
                        <WizardStep
                            cancelButton={true}
                            onBackClick={false}
                            position="middle"
                        >
                            <HireCardAtHomeAbroadStep3
                                handleAccountChange={handleAccountChange}
                                immAccounts={immAccounts}
                                immHireCardAtHomeAbroad={immHireCardAtHomeAbroad}
                                isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                                setAllAccountsToInactive={setAllAccountsToInactive}
                            />
                        </WizardStep>
                        <WizardStep
                            cancelButton={true}
                            onBackClick={false}
                            position="middle"
                            nextButtonDisabled={isShippingAddressButtonDisabled}
                        >
                            <HireCardAtHomeAbroadStep4
                                immHireContactData={immHireContactData}
                                immShippingAddressList={immShippingAddressList}
                                setShippingAddress={setShippingAddress}
                            />
                        </WizardStep>
                        <WizardStep
                            addLoadingBehaviour={true}
                            cancelButton={true}
                            immFinalButton={'hireCardAtHomeAbroad-hire'}
                            isLoading={immHireCardAtHomeAbroad.get('isFetching')}
                            onBackClick={false}
                            position="last"
                        >
                            <HireCardAtHomeAbroadStep5
                                immAccounts={immAccounts}
                                immHireCardAtHomeAbroad={immHireCardAtHomeAbroad}
                                immHireCardNameSelector={immHireCardNameSelector}
                                immPdfData={immPdfData}
                                immShippingAddress={immShippingAddressList.get('shippingAddress')}
                                sendPrecontractualDocumentMail={sendPrecontractualDocumentMail}
                                handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                                setTermsAndCondsText={setTermsAndCondsText}
                            />
                        </WizardStep>
                    </Wizard>
                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                            <HireCardSidebar
                                immAccounts={immAccounts}
                                immHireCardImageSelector={immHireCardImageSelector}
                                immHireCardNameSelector={immHireCardNameSelector}
                                immAddress={immShippingAddress}
                                immShippingAddressList={immShippingAddressList}
                                immProfile={immProfile}
                                selectedAccount={immSteps.getIn([THIRD_STEP, 'accountId'])}
                                type="debit"
                                hasShippingAddress={hasShippingAddress}
                            />
                        </div>
                        <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                            <CallMeBack context="contracts" modifier="contracts-view" pageTitle={formatText('breadcrumb-cards')} hasEntrance={false}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { immHireCardAtHomeAbroad, immFlagBasedFeatures } = this.props;
        const pageTitle = getFinalTitle('hireCardAtHomeAbroad-pageTitle');
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: formatText("hireCardAtHomeAbroad-breadcrumb")
            }
        ];
        let content;

        const processDetail = this.getProcessDetail();
        const hireRestrictionFlag = immHireCardAtHomeAbroad.getIn(['steps', WIZARD_FIRST_STEP - 1, 'hireRestriction']);
        const hireRestrictionFF = immFlagBasedFeatures.get(MESSAGE_HIRE_24H);
        if (immHireCardAtHomeAbroad.get('error')
            || (__CONTACT_CENTER__ && immHireCardAtHomeAbroad.getIn(['steps', FIRST_STEP, 'precontractualLinkInfo', 'error']))) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCardAtHomeAbroadError
                        immHireCardAtHomeAbroad={immHireCardAtHomeAbroad}
                        processDetail={processDetail}
                    />
                </div>
            );
        } else if (hireRestrictionFlag && hireRestrictionFF) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCardAtHomeAbroadError
                        immHireCardAtHomeAbroad={immHireCardAtHomeAbroad}
                        processDetail={processDetail}
                        hireRestrictionFlag={hireRestrictionFlag}
                    />
                </div>
            );
        } else if (immHireCardAtHomeAbroad.get('submitSuccessful')) {
            content = this.buildSuccessful();
        } else {
            content = this.buildWizardHiringSteps();
        }

        return (
            <div className="hire-card-at-home-abroad">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={pageTitle}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HireCardAtHomeAbroadView.propTypes = {
    atHomeAbroadEnabled: PropTypes.bool,
    gestorCrossEnabled: PropTypes.bool,
    getBlockedAccounts: PropTypes.func,
    getPrecontractualInfoLink: PropTypes.func.isRequired,
    getshippingAddressList: PropTypes.func.isRequired,
    handleAccountChange: PropTypes.func.isRequired,
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    hireCardAtHomeAbroad: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immHireCardAtHomeAbroad: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireContactData: PropTypes.object.isRequired,
    immHireInformation: PropTypes.object.isRequired,
    immHiringProductInformation: PropTypes.object.isRequired,
    immPdfData: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immShippingAddressList: PropTypes.object,
    match: PropTypes.object,
    requestPDFMerge: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func,
    resetPrecontractualDocumentMail: PropTypes.func,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetTermsAndCondsText: PropTypes.func.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setShippingAddress: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
};

module.exports.constructor = HireCardAtHomeAbroadView;
module.exports.HireCardAtHomeAbroadView = connect(
    state => ({
        atHomeAbroadEnabled: state.flagBasedFeatures.get('hire-card-at-home-abroad-enabled'),
        flagBasedFeatures: state.flagBasedFeatures,
        gestorCrossEnabled: state.flagBasedFeatures.get('web-gc-enabled'),
        getPrecontractualInfoLink: PropTypes.func.isRequired,
        immAccounts: state.accounts,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immGlobalVariables: state.globalVariables,
        immHireCardImageSelector: state.hireCardImageSelector,
        immHireCardNameSelector: state.hireCardNameSelector,
        immHireCardAtHomeAbroad: state.hireCardAtHomeAbroad,
        immHireContactData: state.hireContactData,
        immHireCreditLimit: state.hireCreditLimit,
        immHireInformation: state.hireInformation,
        immHiringProductInformation: state.hiringProductInformation,
        immHirePaymentMethod: state.hirePaymentMethod,
        immPdfData: state.precontractualsMergePdfs,
        immPreContractualMail: state.preContractualMail,
        immProfile: state.profile,
        immShippingAddressList: state.shippingAddress,
    }),
    {
        getPrecontractualInfoLink: hireCardAtHomeAbroadActions.getPrecontractualInfoLink,
        getshippingAddressList: shippingAddressAction.getShippingAddressList,
        getBlockedAccounts: blockedAccountsAction.getBlockedAccounts,
        handleAccountChange: hireCardAtHomeAbroadActions.setAccount,
        handleAgreementCheckboxChange: hireCardAtHomeAbroadActions.setAgreementCheckbox,
        hireCardAtHomeAbroad: hireCardAtHomeAbroadActions.hireCardAtHomeAbroad,
        requestPDFMerge: mergePreContractualsPDF.requestPDFMerge,
        requestProfile: profileActions.requestProfile,
        reset: hireCardAtHomeAbroadActions.reset,
        resetBlockedAccounts: blockedAccountsAction.resetBlockedAccounts,
        resetPrecontractualDocumentMail: precontractualDocumentMailAction.resetPrecontractualDocumentMail,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        resetTermsAndCondsText: termsAndCondsInfoActions.reset,
        setAllAccountsToInactive: hireCardAtHomeAbroadActions.setAllAccountsToInactive,
        setShippingAddress: shippingAddressAction.setShippingAddress,
        setTermsAndCondsText: termsAndCondsInfoActions.setTermsAndCondsText,
        sendPreContractualMail: preContractualMailActions.sendPreContractualMail,
        sendPrecontractualDocumentMail: precontractualDocumentMailAction.sendPrecontractualDocumentMail,
        setVisibleStep: hireCardAtHomeAbroadActions.setVisibleStep,
        setWillCancel: hireCardAtHomeAbroadActions.setWillCancel,
        validateStep: hireCardAtHomeAbroadActions.validateStep
    }
)(withRouter(HireCardAtHomeAbroadView));
